import React from "react";
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

export const Partners = () => {
    const [emblaRef] = useEmblaCarousel({
        align: 'center',
        skipSnaps: true,
        containScroll: 'trimSnaps',
        loop: true,
        draggable: true,
    }, [Autoplay({ delay: 2000 })]);

    return (
        <section data-bs-version="5.1" className="people4 mbr-embla cid-taYySsvWQW" id="people4-2t">
            <div>
                <div className="container-fluid">
                    <div className="embla" ref={emblaRef}>
                        <div className="embla__container">
                            <div className="embla__slide slider-image item features-image active"
                                 style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                                <div className="slide-content">
                                    <div className="item-wrapper">
                                        <div className="wrap-img item-img">
                                            <img src="/images/1-213x147.jpg" data-slide-to="1" data-bs-slide-to="1" loading="lazy"
                                                 className="lazyload" data-src="assets/images/1-213x147.jpg" alt={""}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="embla__slide slider-image item features-image"
                                 style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                                <div className="slide-content">
                                    <div className="item-wrapper">
                                        <div className="wrap-img item-img">
                                            <img src="/images/2-213x147.jpg" data-slide-to="2" data-bs-slide-to="2" loading="lazy"
                                                 className="lazyload" data-src="assets/images/2-213x147.jpg" alt={""}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="embla__slide slider-image item features-image"
                                 style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                                <div className="slide-content">
                                    <div className="item-wrapper">
                                        <div className="wrap-img item-img">
                                            <img src="/images/4-213x147.jpg" data-slide-to="2" data-bs-slide-to="2" loading="lazy"
                                                 className="lazyload" data-src="assets/images/4-213x147.jpg" alt={""}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="embla__slide slider-image item features-image"
                                 style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                                <div className="slide-content">
                                    <div className="item-wrapper">
                                        <div className="wrap-img item-img">
                                            <img src="/images/5-213x147.jpg" data-slide-to="3" data-bs-slide-to="3" loading="lazy"
                                                 className="lazyload" data-src="assets/images/5-213x147.jpg" alt={""}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="embla__slide slider-image item features-image"
                                 style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                                <div className="slide-content">
                                    <div className="item-wrapper">
                                        <div className="wrap-img item-img">
                                            <img src="/images/6-213x147.jpg" data-slide-to="4" data-bs-slide-to="4" loading="lazy"
                                                 className="lazyload" data-src="assets/images/6-213x147.jpg" alt={""}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="embla__button embla__button--prev">
                            <span className="mobi-mbri mobi-mbri-arrow-prev mbr-iconfont" aria-hidden="true"></span>
                            <span className="sr-only visually-hidden visually-hidden">Previous</span>
                        </button>
                        <button className="embla__button embla__button--next">
                            <span className="mobi-mbri mobi-mbri-arrow-next mbr-iconfont" aria-hidden="true"></span>
                            <span className="sr-only visually-hidden visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}